import e from "./SchemaGutterToggle.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/SchemaGutterToggle.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaGutterToggle.vue.js.map